import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FileItem, FileUploader } from 'ng2-file-upload';
import { SnackBarService } from '../../services/snackbar.service';
import { Subscription } from 'rxjs';
import { AWSService } from '../../services/aws.service';
import { DocumentScanEvent } from '../../models/documentScanEvent';
import { DocumentScanStatusType } from '../../models/documentScanStatusType';
import { oneMb } from '../../../../shared-app-portal/components/document-upload/document-upload.helper';
const maxFileSizeInMb = 10;
@Component({
  selector: 'credential-pdf-file-upload',
  templateUrl: './credential-pdf-file-upload.component.html',
  styleUrls: ['./credential-pdf-file-upload.component.scss'],
  standalone: false
})
export class CredentialPdfFileUpload implements OnInit {
  virusScanSubscription: Subscription;
  @Input() buttonLabel: string = 'Upload Font';
  @Input() uploadButtonClass: string = '';
  @Input()
  onFileUpload: (file: FileItem) => void;
  @Input() uploadColor: string = '';
  @Input() iconDisplay: string = '';
  displayDocumentScanningMessage: boolean = false;
  allowedExtensions: string[] = ['ttf', 'pdf'];
  @Output() virusScanResultEvent = new EventEmitter<DocumentScanEvent>();
  @Input() acceptedFileTypes: acceptedFileTypes;

  uploader: FileUploader = new FileUploader({
    url: '',
    autoUpload: false,
    filters: [
      {
        name: 'fontFilter',
        fn: (item: any) => {
          const ext = item.name.slice(item.name.lastIndexOf('.') + 1).toLowerCase();
          if (this.allowedExtensions.indexOf(ext) !== -1) {
            return true;
          }
          return false;
        }
      }
    ]
  });

  constructor(
    private snackBar: SnackBarService,
    private awsService: AWSService
  ) {
    this.virusScanSubscription = this.awsService.virusScanResult.subscribe((result) => {
      this.virusScanResultEvent.emit({
        status: result.status,
        documentPassedScan: result.documentPassedScan,
        errorMessage: result.errorMessage
      });
      this.displayDocumentScanningMessage = false;
    });
  }

  ngOnInit() {
    this.uploader.onAfterAddingFile = (fileItem) => {
      let fileSize = Math.round((fileItem.file.size / oneMb) * 100) / 100;
      if (fileSize > maxFileSizeInMb) {
        let errorMessage = `Maximum upload size exceeded (${fileSize} MB of ${maxFileSizeInMb} MB allowed)`;
        this.snackBar.open(errorMessage, false);
        return;
      }

      this.displayDocumentScanningMessage = true;
      this.awsService.scanForVirus(fileItem);
      this.virusScanResultEvent.emit({
        status: DocumentScanStatusType.Started,
        documentPassedScan: false
      });

      fileItem.withCredentials = false;
      fileItem.file.type = 'font/ttf';
      if (this.onFileUpload) {
        this.onFileUpload(fileItem);
      }
    };

    this.uploader.onWhenAddingFileFailed = () => {
      const errorMessage = `File type not allowed. Allowed types: ${this.allowedExtensions.join(
        ', '
      )}`;
      this.snackBar.open(errorMessage, false);
    };
  }

  ngOnDestroy() {
    this.virusScanSubscription.unsubscribe();
  }
}

type acceptedFileTypes = '.pdf' | '.ttf';
